module.exports = __webpack_public_path__ + "img/level_low.9fba16c6.png";